import React, { useState, useEffect } from 'react';
import { host_url } from '../../App'; // Import host_url
import '../../styles/CiTable.css';
import BackArrow from '../../BackArrow'; // Importiere die BackArrow-Komponente

function Spuelplan() {
  const [dienstplaene, setDienstplaene] = useState([]);

  useEffect(() => {
    fetch(`${host_url}/dienstplaene`)
      .then((response) => response.json())
      .then((data) => setDienstplaene(data))
      .catch((error) => console.error("Fehler:", error));
  }, []);

  const filteredDienstplaene = dienstplaene.filter(plan => 
    plan.Dienst.includes('Spül') || plan.Dienst.includes('Abwasch')
  );

  const groupedByDate = filteredDienstplaene.reduce((acc, plan) => {
    const date = plan.Datum;
    if (!acc[date]) {
      acc[date] = [];
    }
    acc[date].push(plan);
    return acc;
  }, {});

  return (
    <div>
            <div className="page-header">
        <BackArrow to="/dienstplaene" />
        <h1>Spülplan</h1>
      </div>
      {Object.keys(groupedByDate).length === 0 && (
        <p>Es sind noch keine Spüldienste eingetragen.</p>
      )}
      {Object.keys(groupedByDate)
        .sort((a, b) => new Date(a) - new Date(b)) // Sortiere die Daten chronologisch
        .map((date) => (
        <div key={date}>
          <h2>{new Date(date).toLocaleDateString('de-DE')}</h2>
          <div className="ci-table-wrapper">
          <table className="ci-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Bereich</th>
                <th>Uhrzeit</th>
              </tr>
            </thead>
            <tbody>
              {groupedByDate[date]
                .sort((a, b) => {
                  const timeA = a.Uhrzeit.split(':').map(Number);
                  const timeB = b.Uhrzeit.split(':').map(Number);
                  return timeA[0] - timeB[0] || timeA[1] - timeB[1];
                })
                .map((plan) => (
                  <tr key={plan.Teamer}>
                    <td>{plan.Teamer}</td>
                    <td>{plan.Bereich}</td>
                    <td>{plan.Uhrzeit}</td>
                  </tr>
                ))}
            </tbody>
          </table>
          </div>
        </div>
      ))}
    </div>
  );
}

export default Spuelplan;
